export default "__VITE_ASSET__9ac87971__"